import { Navigate } from "react-router-dom"
import { routes } from "../utils"
import { CommunityRoutes } from "./CommunityRoutes"
import { OwnersReport, PropertyReport, UserManagement } from "@/pages"

export const AdminConsoleRoutes = () => {
  return {
    path: routes.adminConsole,
    children: [
      {
        path: "",
        element: (
          <Navigate
            to={`/${routes.admin}/${routes.adminConsole}/${routes.communities}`}
          />
        ),
      },
      CommunityRoutes(),
      {
        path: routes.ownerReport,
        element: <OwnersReport />
      },
      {
        path: routes.propertyReport,
        element: <PropertyReport />
      },
      {
        // Admin routes only — not mounted for CAM
        path: routes.userManagement,
        element: <UserManagement />
      },
    ]
  }
}